import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=2187d65a&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports